import React, { useMemo } from "react";
import { useMentoredStudentsCount } from "../../query/hooks/QueryHooksDashboard";
import { generateFetchDataPayload, getDigitClass } from "./util";

export default function MentoredStudentsBadge({
    filterIntake,
    filterLearningMethod,
    filterLecturer,
    filterSchool
}) {
    const filters = useMemo(
        () =>
            generateFetchDataPayload({
                filterIntake,
                filterSchool,
                filterLearningMethod,
                filterLecturer
            }),
        [filterIntake, filterSchool, filterLearningMethod, filterLecturer]
    );

    const {
        data: mentoredCount,
        isLoading,
        isError
    } = useMentoredStudentsCount(filters);

    const pendingSignOffClass = useMemo(
        () => getDigitClass(mentoredCount?.pending_sign_off),
        [mentoredCount?.pending_sign_off]
    );

    const notesPendingClass = useMemo(
        () => getDigitClass(mentoredCount?.notes_pending_response),
        [mentoredCount?.notes_pending_response]
    );
    
    if (isLoading) {
        return (
            <span className="dashboard-loading">
                <i className="fas fa-cog fa-spin"></i>
            </span>
        );
    }
    
    if (isError) {
        return null;
    }

    return (
        <>
            <span className="nav-fa-comments" title="Students Pending Sign-off">
                <small className={`notify-count ${pendingSignOffClass}`}>
                    {mentoredCount?.pending_sign_off ?? 0}
                </small>
                <i className="fal fa-calendar comments"></i>
            </span>

            <span className="nav-fa-comments ml-3" title="Notes Pending Response">
                <small className={`notify-count ${notesPendingClass}`}>
                    {mentoredCount?.notes_pending_response ?? 0}
                </small>
                <i className="fal fa-comment-alt-dots comments"></i>
            </span>
        </>
    );
}
